module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABUUExURf8/AP9PFf///////wAAAP/MvP9/Vf///wAAAP+JYwAAAAAAAP7+/v/18SwsLP39/eLi4vz8/Pb29vX19QAAAIuLi4CAgAAAALS0tAAAAKGhof///1v/zY4AAAAbdFJOU42S1vME0aX+AqoYEb7zI5YwkZqVCwsMFD0gREEHKtYAAACESURBVBjTZY9ZEoMwDEOV1WkCWdl9/3uWMm2BQX96M7YkOOd0LlIpWbLeDZweE/EhSqN20FPHZKwQ1hB3k4ZO3L9w6NVz0shEX78ToozCBn8ZLpBsT2BZQrE4gWD1BI+Tdn/asNxjF/h6LVY95nitHmcEH+tvXI0+YAh+3dpnfttWH4Y3SzEIm7lOZ7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/oval_light.png
// module id = 493
// module chunks = 0